<template>
  <div>
    <validation-observer ref="cancellationObserver" novalidate>
      <div class="px-4 py-1">
        <div class="mb-3 font-weight-bold">
          <i class="fas fa-times-circle text-orange mr-2"></i>
          Razón de Cancelación de Transferencia
        </div>
      </div>
      <div class="px-4 font-weight-normal">
        <validation-provider
          class="w-100"
          name="Comentario"
          rules="required"
          v-slot="{ errors }"
        >
          <label>Comentario:</label>
          <custom-text-area
            :maxlength="3000"
            v-model="cancellationReason"
            :error="errors[0]"
            :custom-error-msg="'Este campo es requerido.'"
            name="cancellationReason"
            id="cancellationReason"
          />
        </validation-provider>
      </div>

      <div class="d-flex justify-content-end align-items-center px-4 mt-4 pb-3">
        <action-button
          id="btnCancel"
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 px-3"
          @click="handlerClose()"
        />
        <action-button
          id="btnSave"
          i="fas fa-save"
          text="Guardar"
          variant="success px-3"
          @click="cancelTransfer()"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import mixAlert from '@/mixins/alert.mixin';
import CustomTextArea from '@/components/common/form/CustomTextArea';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
export default {
  name: 'TransferCancellation',
  components: {
    CustomTextArea,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
  },
  mixins: [mixAlert],
  props: {
    equipmentId: {
      type: Number,
      required: true,
    },
    recommendationId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      cancellationReason: null,
    };
  },
  computed: {},
  methods: {
    handlerClose() {
      this.$emit('close');
    },
    async cancelTransfer() {
      var isValid = await this.$refs.cancellationObserver.validate();
      if (!isValid) {
        return;
      }
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea cancelar la solicitud?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }
      var payload = {
        cancellationReason: this.cancellationReason,
        recommendationId: this.recommendationId,
      };
      inventoryCatalogService
        .cancelInventoryTransfer(this.equipmentId, payload)
        .then(() => {
          this.ShowToast(
            'Éxito',
            'La transferencia se ha cancelado exitosamente.',
            'success'
          );
          this.cancellationReason = null;
          this.$emit('refresh');
        })
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
    },
  },
};
</script>
<style lang="scss"></style>
